import { ref } from 'vue';

// Shared reactive state for pre-selecting a snapshot in AppStartModal
const presetSnapshotId = ref(null);

export function usePresetSnapshot() {
  return { presetSnapshotId };
}
